import { render } from "./field_context_menu.vue?vue&type=template&id=3aaf2b9a"
import script from "./field_context_menu.vue?vue&type=script&lang=js"
export * from "./field_context_menu.vue?vue&type=script&lang=js"

import exportComponent from "/opt/docuseal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__